import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import styles from './DocumentResultRow.module.css';

export default function DocumentResultRow({ doc, onFeedbackSubmit, classificationOptions }) {
    const [feedbackState, setFeedbackState] = useState("pending");
    const [selectedOption, setSelectedOption] = useState(null);

    // On mount: pre-fill state from doc
    useEffect(() => {
        if (doc.isCorrect === true) {
            setFeedbackState("yes");
        } else if (doc.isCorrect === false) {
            setFeedbackState("noConfirmed");

            if (doc.correctClassificationId) {
                const match = classificationOptions.find(opt => opt.value === doc.correctClassificationId || opt.id === doc.correctClassificationId);
                if (match) setSelectedOption({ label: match.name || match.label, value: match.id || match.value });
            }
        }
    }, [doc, classificationOptions]);

    const handleYes = async () => {
        await onFeedbackSubmit(doc.id, true, null);
        setFeedbackState("yes");
    };

    const handleNo = () => {
        setFeedbackState("noEditing");
    };

    const handleConfirmNo = async () => {
        await onFeedbackSubmit(doc.id, false, selectedOption ? selectedOption.value : null);
        setFeedbackState("noConfirmed");
    };

    const handleChangeFeedback = () => {
        setFeedbackState("pending");
        setSelectedOption(null);
    };

    return (
        <tr>
            <td>{doc.docType}</td>
            <td>{doc.pageRange}</td>
            <td>{(doc.confidence * 100).toFixed(1)}%</td>
            <td>
                {feedbackState === "pending" && (
                    <>
                        <button onClick={handleYes} className={styles.feedbackButton}>Yes</button>
                        <button onClick={handleNo} className={styles.feedbackButton}>No</button>
                    </>
                )}
                {feedbackState === "yes" && (
                    <span className={styles.feedbackYes}>Yes</span>
                )}
                {feedbackState === "noEditing" && (
                    <>
                        <Select
                            options={classificationOptions}
                            value={selectedOption}
                            onChange={setSelectedOption}
                            placeholder="Select classification (optional)..."
                            isSearchable
                            className={styles.select}
                        />
                        <button onClick={handleConfirmNo} className={styles.confirmButton}>OK</button>
                    </>
                )}
                {feedbackState === "noConfirmed" && (
                    <span className={styles.feedbackNo}>
                        No{selectedOption ? `: ${selectedOption.label}` : ""}
                    </span>
                )}
                {(feedbackState === "yes" || feedbackState === "noConfirmed") && (
                    <button onClick={handleChangeFeedback} className={styles.changeLink}>Change</button>
                )}
            </td>
        </tr>
    );
}
